import { useTranslation } from '../utils/useTranslation';
import { ChevronDown, MessageCircle, Gift, Palette, Bot, Shuffle } from 'lucide-react';
import { useState } from 'react';

interface PublicMenuProps {
    onNavigate: (view: 'home' | 'feature-messages' | 'feature-wishlist' | 'feature-themes' | 'feature-ai' | 'feature-draw' | 'blog') => void;
}

export function PublicMenu({ onNavigate }: PublicMenuProps) {
    const { t } = useTranslation();
    const [showFeatures, setShowFeatures] = useState(false);

    return (
        <div className="flex items-center gap-6">
            <button
                onClick={() => onNavigate('home')}
                className="text-gray-700 hover:text-purple-600 font-medium transition-colors px-3 py-2 rounded-lg hover:bg-purple-50"
            >
                {t('nav.home')}
            </button>

            {/* Dropdown de Recursos/Features */}
            <div className="relative"
                onMouseEnter={() => setShowFeatures(true)}
                onMouseLeave={() => setShowFeatures(false)}
            >
                <button
                    className="text-gray-700 hover:text-blue-600 font-medium transition-colors px-3 py-2 rounded-lg hover:bg-blue-50 flex items-center gap-1"
                >
                    {t('nav.features')}
                    <ChevronDown className="w-4 h-4" />
                </button>

                {showFeatures && (
                    <div className="absolute top-full left-0 mt-1 bg-white rounded-lg shadow-lg border border-gray-200 py-2 min-w-[240px] z-50">
                        <button
                            onClick={() => {
                                setShowFeatures(false);
                                onNavigate('feature-messages');
                            }}
                            className="w-full text-left px-4 py-3 text-gray-700 hover:bg-purple-50 hover:text-purple-600 transition-colors flex items-center gap-3 group"
                        >
                            <MessageCircle className="w-5 h-5 text-gray-400 group-hover:text-purple-600 transition-colors" />
                            <span>{t('nav.messages')}</span>
                        </button>
                        <button
                            onClick={() => {
                                setShowFeatures(false);
                                onNavigate('feature-wishlist');
                            }}
                            className="w-full text-left px-4 py-3 text-gray-700 hover:bg-purple-50 hover:text-purple-600 transition-colors flex items-center gap-3 group"
                        >
                            <Gift className="w-5 h-5 text-gray-400 group-hover:text-purple-600 transition-colors" />
                            <span>{t('nav.wishlist')}</span>
                        </button>
                        <button
                            onClick={() => {
                                setShowFeatures(false);
                                onNavigate('feature-themes');
                            }}
                            className="w-full text-left px-4 py-3 text-gray-700 hover:bg-purple-50 hover:text-purple-600 transition-colors flex items-center gap-3 group"
                        >
                            <Palette className="w-5 h-5 text-gray-400 group-hover:text-purple-600 transition-colors" />
                            <span>{t('nav.themes')}</span>
                        </button>
                        <button
                            onClick={() => {
                                setShowFeatures(false);
                                onNavigate('feature-ai');
                            }}
                            className="w-full text-left px-4 py-3 text-gray-700 hover:bg-purple-50 hover:text-purple-600 transition-colors flex items-center gap-3 group"
                        >
                            <Bot className="w-5 h-5 text-gray-400 group-hover:text-purple-600 transition-colors" />
                            <span>{t('nav.ai')}</span>
                        </button>
                        <button
                            onClick={() => {
                                setShowFeatures(false);
                                onNavigate('feature-draw');
                            }}
                            className="w-full text-left px-4 py-3 text-gray-700 hover:bg-purple-50 hover:text-purple-600 transition-colors flex items-center gap-3 group"
                        >
                            <Shuffle className="w-5 h-5 text-gray-400 group-hover:text-purple-600 transition-colors" />
                            <span>Sorteio & Revelação</span>
                        </button>
                    </div>
                )}
            </div>

            <button
                onClick={() => onNavigate('blog')}
                className="text-gray-700 hover:text-orange-600 font-medium transition-colors px-3 py-2 rounded-lg hover:bg-orange-50"
            >
                {t('nav.blog')}
            </button>
        </div>
    );
}
